import { DiscordIcon } from '@/components/icons/socials/DiscordIcon';
import { FacebookIcon } from '@/components/icons/socials/FacebookIcon';
import { InstagramIcon } from '@/components/icons/socials/InstagramIcon';
import { TelegramIcon } from '@/components/icons/socials/TelegramIcon';
import { TiktokIcon as TikTokIcon } from '@/components/icons/socials/TiktokIcon';
import { TwitterIcon } from '@/components/icons/socials/TwitterIcon';
import { YoutubeIcon } from '@/components/icons/socials/YoutubeIcon';

export const SOCIAL_NAVIGATION_LINKS = [
  {
    name: 'Twitter',
    href: 'https://linktr.ee/gocorex',
    icon: TwitterIcon,
  },
  {
    name: 'YouTube',
    href: 'https://linktr.ee/gocoreyoutube',
    icon: YoutubeIcon,
  },
  {
    name: 'Instagram',
    href: 'https://linktr.ee/gocoreinstagram',
    icon: InstagramIcon,
  },
  {
    name: 'TikTok',
    href: 'https://linktr.ee/gocoretiktok',
    icon: TikTokIcon,
  },
  {
    name: 'Facebook',
    href: 'https://linktr.ee/gocorefacebook',
    icon: FacebookIcon,
  },
  {
    name: 'Telegram',
    href: 'https://t.me/GOCOREGG',
    icon: TelegramIcon,
  },
  {
    name: 'Discord',
    href: 'https://discord.gg/tG5etK3ZeZ',
    icon: DiscordIcon,
  },
];
